//var path    = "https://edreamzconcepts.com/shopify_apps/edreamz_conceptodoha_app";
//var path    = "https://edreamzconcepts.com/shopify_apps/edreamz_conceptodoha_client_app";
var path    = "https://conceptodohaapp.com/";
//var path    = "https://webdevfolio.com/shopifyapps/Concepto-version2/";
var shopurl = Shopify.shop;
var ip_address = "";
var customer_id = "";




if(!window.jQuery)

{

	var imported = document.createElement('script');

	imported.src = path + '/assets/js/jquery-1.12.3.min.js';

	/*imported.src = path + '/assets/js/jquery.cookie.js';*/   

	document.head.appendChild(imported);

}



$(document).ready(function($) {



    var currenturl      =  window.location.href; 

    var find            =  'products/';





    if((currenturl.indexOf(find) != -1))

    {

    	var variant_id = $("#ProductSelect-product-template").val();

    	customer_id = $("#customer_id").val();


		$.getJSON('https://jsonip.com').done(function(data) {

		    ip_address_data = window.JSON.parse(JSON.stringify(data, null, 2));
		    ip_address = ip_address_data.ip;

      		get_custom_design_settings(variant_id);

          $('<input>').attr({
              type: 'hidden',
              id: 'ip_address',
              name: 'ip_address',
              value:ip_address
          }).appendTo('body');


		});







    }









    console.log("currenturl:"+currenturl);







   // to save customize settings into database

   

   





   

     //checkout button with getProduct()

                $('#save-settings-button1').click(function () {

                    var product = yourDesigner.getProduct();

    				var variant_id = $("#ProductSelect-product-template").val();
                  
                    $("#save-settings-loader").show();

                    $("#save-settings-button").prop('disabled','disabled');
                    console.log("ip_address123"+ip_address);            
  

                    //return false;

                        $.ajax({

                            url: path+'/homepage/save_customer_case_setting',

                            type: 'post',

                            data: {variant_id:variant_id,customer_id:customer_id,ip_address:ip_address,customize_settings: product},

                            dataType: 'json',                            

                            success: function (response) {


    

                    $("#save-settings-loader").hide();

                    $(".setting_saved_message").show().fadeOut(3500)

                    $("#save-settings-button").prop('disabled',false);

                    

                              

                            

                        }

                    });



                    return false;

                });

   

   



});



$(window).bind("load", function() {

   console.log("All page load");

      var variant_id = $("#ProductSelect-product-template").val();

});





$(document).on("click","#save-settings-button", function(){
                    var product = yourDesigner.getProduct();
                    var variant_id = $("#ProductSelect-product-template").val();

                     var ip_address_new = $("#ip_address").val();
 
   console.log("jvkjkv");

                    $("#save-settings-loader").show();

                    $("#save-settings-button").prop('disabled','disabled');





                        $.ajax({

                            url: path+'/homepage/save_customer_case_setting',

                            type: 'post',

                            data: {variant_id:variant_id,customer_id:customer_id,ip_address:ip_address_new,customize_settings: product},

                            dataType: 'json',                            

                            success: function (response) {
                              
                    $("#save-settings-loader").hide();

                    $(".setting_saved").show().fadeOut(3500)

                    $("#save-settings-button").prop('disabled',false);

                    

                              

                            

                        }

                    });



                    return false;

});
